import axiosInstance from '../../axios-config';

const postInvitedAuthRepUrl = '/api/invitations/contact/{0}/invite';
const getArInviteExistsUrl = '/api/invitations/contact/{0}/checkArInviteExists';

export const postInvitedAuthRep = (contactId) =>
  axiosInstance.post(postInvitedAuthRepUrl.replace('{0}', contactId));

export const getArInviteExists = (contactId) =>
  axiosInstance.get(getArInviteExistsUrl.replace('{0}', contactId));

